import useWidth from '@components/Hooks/useWidth';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';
import { useIsRachelAvailable } from '../hooks/useIsRachelAvailable';
import { useRachelPageNavigation } from '../hooks/useRachelPageNavigation';
import RachelSparkActionIcon from './RachelSparkIcon/RachelSparkActionIcon';

const RachelTrigger = () => {
  const isAvailable = useIsRachelAvailable();
  const { mobileWidth } = useWidth();
  const { openPage } = useRachelPageNavigation();
  const { translate } = useTranslation();

  if (!isAvailable || !mobileWidth) {
    return null;
  }

  return (
    <IconButton
      icon={RachelSparkActionIcon}
      size="medium"
      testId="rachel-trigger"
      ariaLabel={translate(LangEnum.RACHEL_OPEN)}
      onClick={openPage}
    />
  );
};

export default RachelTrigger;
